import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function FlashSaleBar() {
  const {
    formattedTime
  } = useCountdown(undefined, 900);
  return <div className="bg-[#F5F5F0] text-[#4a4a4a] py-2 px-4 flex justify-center items-center border-b border-[#E5E5E0] font-sans text-[11px] tracking-wide uppercase sticky top-0 z-[1000]" data-id="element-146">
      <span className="mr-2 font-medium" data-id="element-147">
        Special Reader Pricing — Limited Availability
      </span>
      <span className="text-[#8B2500] font-bold tabular-nums" data-id="element-148">
        {formattedTime}
      </span>
    </div>;
}